module.exports = __webpack_public_path__ + "static/media/_sardinia.5505903c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_sardinia.svg
// module id = 2348
// module chunks = 7